import apiClient from './api';

export const examenService = {
  // Listar todos los exámenes
  getAllExamenes: async () => {
    const response = await apiClient.get('/examenes');
    return response.data;
  },

  // Obtener examen por ID
  getExamenById: async (id) => {
    const response = await apiClient.get(`/examenes/${id}`);
    return response.data;
  },

  // Listar exámenes por perfil
  getExamenesByPerfil: async (perfilId) => {
    const response = await apiClient.get(`/examenes/perfil/${perfilId}`);
    return response.data;
  },

  // Crear nuevo examen
  createExamen: async (examenData) => {
    const response = await apiClient.post('/examenes', examenData);
    return response.data;
  },

  // Actualizar examen
  updateExamen: async (id, examenData) => {
    const response = await apiClient.put(`/examenes/${id}`, examenData);
    return response.data;
  },

  // Eliminar examen
  deleteExamen: async (id) => {
    const response = await apiClient.delete(`/examenes/${id}`);
    return response.data;
  },

  // Actualizar estado del examen
  actualizarEstadoExamen: async (id, estado, examenData) => {
    // Obtener el examen actual primero
    const examenActual = await apiClient.get(`/examenes/${id}`);
    
    // Actualizar con el nuevo estado y los datos existentes
    const response = await apiClient.put(`/examenes/${id}`, {
      ...examenActual.data,
      ...examenData,
      estado: estado
    });
    return response.data;
  },

  // Iniciar examen (cambiar a PROGRESO)
  iniciarExamen: async (examenId) => {
    return examenService.actualizarEstadoExamen(examenId, 'PROGRESO');
  },

  // Finalizar examen (cambiar a FINALIZADO)
  finalizarExamen: async (examenId) => {
    return examenService.actualizarEstadoExamen(examenId, 'FINALIZADO');
  },
};

export default examenService;
